/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichText } from "cms/rich-text";
import { clsx } from "clsx";
import { ReactComponent as ExpandIcon } from "cms/assets/icons/chevron-down.svg";
import { ReactComponent as CollapseIcon } from "cms/assets/icons/chevron-up.svg";

const AccordionSection = (props) => {
    const section = props?.section;
    const selectSection = props?.selectSection;
    const tabindex = props?.tabIndex ?? 0;
    const group_id = props?.group_id;
    const stepNumber = props?.stepNumber;
    const showSteps = props?.showSteps;

    const richtext = section?.richtext;
    const tab_id = section?.tab_id;
    const title  = section?.title ?? "Title missing";
    const isVisible = section?.isVisible;

    const guid = tab_id;
    const instance_id = tab_id;
    const panel = `panelGroup_panel-${group_id}-${instance_id}`;
    const label = `panelGroup_tab-${group_id}-${instance_id}`;
    const visibility = isVisible ? "open" : "closed";

    const containerClassName = clsx("simplicity-accordion", visibility, {
        first: tabindex === 0,
    });

    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            selectSection(guid, event);
        }
    };

    return (
        <div className={containerClassName}>
            {showSteps && (
                <div className="step-container">
                    <h6>{stepNumber}</h6>
                </div>
            )}

            <div className="accordion-container">
                <div
                    className="accordion-header"
                    onClick={(event) => selectSection(guid, event)}
                    onKeyDown={handleKeyDown}
                    role="tab"
                    id={instance_id}
                    aria-controls={panel}
                    tabIndex={0}
                    aria-expanded="false"
                    aria-selected="false"
                >
                    <p>{title}</p>
                    <span>
                        {isVisible &&
                            <CollapseIcon />
                        }
                        {!isVisible &&
                            <ExpandIcon />
                        }
                    </span>
                </div>
                <div
                    className={"accordion-section-content"}
                    role="tabpanel"
                    aria-labelledby={label}
                    id={panel}
                >
                    <RichText richtext={richtext} />
                </div>
            </div>
        </div>
    );
};

AccordionSection.displayName = "AccordionSection";
export { AccordionSection };
